/* import React from "react"; */
import { Link, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import HomeVideo from "./HomeVideo";


const AboutChaashniWA = () => {


   const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);


  const desktopRef = useRef(null);
   const mobileRef = useRef(null);
  
    useEffect(() => {
      const isMobile = window.innerWidth <= 768; // adjust as needed
  
      const playVideo = () => {
        const video = isMobile ? mobileRef.current : desktopRef.current;
        if (video) {
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch((err) => {
              console.warn('Autoplay error:', err);
            });
          }
        }
      };
  
      if (document.readyState === 'complete') {
        setTimeout(playVideo, 100); // short delay improves iOS behavior
      } else {
        window.addEventListener('load', () => setTimeout(playVideo, 100));
      }
    }, []);
  return (
    <div className="about-chaashni-full">
      <div className="container">
        <h2 className="newfont-heading">About Chaashni & the फाउंडर्स{/* ABOUT CHAASHNI & THE FOUNDERS */}</h2>
        <p>Founded by Maansi and Ketan, Chaashni is a passion project rooted in elegance and artistry.<br />
          Together, they create pieces that embody grace and craftsmanship, making every garment a cherished experience.</p>
        <p>Here's more about them and the team behind Chaashni.</p>

        <ul className="about-section">
          
          <li>
          <Link to=""><img src="/images/about/the-people-chaashni.jpg" alt="The People of Chaashni" /></Link>
            <p><Link to="">The People of Chaashni</Link></p>
          </li>
          <li>
            <Link to=""><img src="/images/about/maansiandketan.jpg" alt="MaansiAndKetan" /></Link>
            <p><Link to="">About Maansi <img src="/images/about/Lotus-Black.png" alt="" /> Ketan</Link></p>
          </li>
          <li>            
            <Link to=""><img src="/images/about/chaashni-women.jpg" alt="The Women Chaashni" /></Link>
            <p><Link to="">The Women of Chaashni  - Our customers, Our pride.</Link></p>
          </li>
        </ul>
              <HomeVideo />
      </div>
    </div>
  );
};

export default AboutChaashniWA;
